import { format, unwrapFunctionStore } from 'svelte-i18n';

import { campaignsSettingsStore } from '@client/stores/page-settings';

import { typeCharacters } from '@client/utils/dom';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const targetingModal = {
  element: '.modal-content',
  popover: {
    title: 'Targeting Details',
    description: `
      Targeting is optional but great for account-based marketing to specific recipients or domains.
      <br/><br/>
      <strong>Important</strong>
      <br/>
      <ul>
        <li>Recipient-based or domain-based targeting keeps banners live for those targets, even after scheduling ends.</li>
        <li>Remove targeting if you don't want banners to keep showing.</li>
      </ul>
      `,
    side: 'right',
    align: 'center',
    onPrevClick: () => {
      const backButton = document.querySelector('.back');

      if (backButton) {
        backButton.click();

        setTimeout(() => {
          GLOBAL_DRIVER_OBJECT.movePrevious();
        }, 200);
      }
    }
  }
};

export const targetingModalRecipient = {
  element: 'div.modal-body > div > div > div:nth-child(1)',
  popover: {
    title: 'Recipient-Based Targeting',
    description: `
    Use recipient-based targeting to show banners to specific email addresses.
    <br/><br/>
    <strong>How it works</strong>
    <br/>
    <ul>
      <li>Enter one or more email addresses to directly target individual recipients.</li>
      <li>Ideal for personalized campaigns or reaching specific contacts.</li>
    </ul>
    `,
    side: 'right',
    align: 'center',
    onPopoverRender: () => {
      const addRecipientBtn = document.querySelector(
        'div.modal-body > div > div > div:nth-child(1) > div.campaign-actions > div > div > button'
      );

      const recipientInput = document.querySelector(
        'div.modal-body > div > div > div:nth-child(1) > div.campaign-actions > div > ul > li > div > input'
      );

      if (addRecipientBtn && !recipientInput) {
        addRecipientBtn.click();
      }

      setTimeout(() => {
        const recipientInput = document.querySelector(
          'div.modal-body > div > div > div:nth-child(1) > div.campaign-actions > div > ul > li > div > input'
        );

        if (recipientInput && recipientInput.value === '') {
          typeCharacters(recipientInput, 'tour-recipient@opensense.com', 75);
        }
      }, 50);
    }
  }
};

export const targetingModalDomain = {
  element: 'div.modal-body > div > div > div:nth-child(2)',
  popover: {
    title: 'Domain-Based Targeting',
    description: `
    Use domain-based targeting to show banners to recipients with specific email domains.
    <br/><br/>
    <strong>How it works</strong>
    <br/>
    <ul>
      <li>Add one or more domains (e.g., example.com) to target all email addresses within those domains.</li>
      <li>Perfect for targeting companies, departments, or partners.</li>
    </ul>
    `,
    side: 'right',
    align: 'center',
    onPopoverRender: () => {
      const addDomainBtn = document.querySelector(
        'div.modal-body > div > div > div:nth-child(2) > div.campaign-actions > div > div > button'
      );
      const domainInput = document.querySelector(
        'div.modal-body > div > div > div:nth-child(2) > div.campaign-actions > div > ul > li > div > input'
      );

      if (addDomainBtn && !domainInput) {
        addDomainBtn.click();
      }
      setTimeout(() => {
        const domainInput = document.querySelector(
          'div.modal-body > div > div > div:nth-child(2) > div.campaign-actions > div > ul > li > div > input'
        );

        if (domainInput && domainInput.value === '') {
          typeCharacters(domainInput, 'tourdomain.com', 75);
        }
      }, 50);
    }
  }
};

export const clickCreateCampaign = {
  element: '#modal-create-btn',
  popover: {
    title: 'Create Campaign',
    description:
      "When you're done, click <strong>&quot;Create Campaign&quot;</strong> to finish up. You'll be taken to the campaign editor page to view metrics, details, and insights.",
    side: 'bottom',
    align: 'center',
    onNextClick: () => {
      const closeButton = document.querySelector('.close');

      campaignsSettingsStore.subscribe((campaigns) => {
        campaigns.tours.createHasToured = true;
      })();

      if (closeButton) {
        closeButton.click();

        GLOBAL_DRIVER_OBJECT.destroy();
      }
    }
  }
};
